var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromoIconinline = function SvgPromoIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 104 105"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D822B",
    stroke: "#2D822B",
    strokeWidth: 1.972,
    d: "M73.451 17.297c-7.581 0-13.727 6.146-13.727 13.727S65.87 44.752 73.45 44.752 87.18 38.606 87.18 31.024 81.032 17.297 73.45 17.297Zm0 21.87a7.94 7.94 0 0 1-7.952-7.953c0-4.4 3.552-7.952 7.952-7.952s7.952 3.552 7.952 7.952-3.552 7.952-7.952 7.952Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D822B",
    stroke: "#2D822B",
    strokeWidth: 1.972,
    d: "m60.493 2.45-.025.001-.025.002c-4.79.4-9.195 2.4-12.596 5.8L5.439 50.663c-5.9 5.9-5.9 15.462 0 21.363l.617-.617-.617.617 27.003 27.003c2.84 2.841 6.702 4.473 10.587 4.473 3.848 0 7.729-1.417 10.598-4.485L96.023 56.62c3.406-3.406 5.403-7.811 5.8-12.79l.002-.02.001-.02 1.141-29.277c.205-3.546-1.258-6.85-3.71-9.303C96.77 2.725 93.468 1.498 90 1.498h-.837l-.005.028zm31.662 49.924.64.64-.64-.64-42.598 42.599a9.23 9.23 0 0 1-13.059 0L9.496 67.969a9.23 9.23 0 0 1 0-13.058l42.408-42.408c2.32-2.32 5.518-3.91 8.857-4.087h.007l29.252-1.14c2.03.004 3.669.672 4.988 1.993 1.314 1.314 1.991 3.14 1.994 4.995l-.76 29.26c-.179 3.336-1.767 6.532-4.086 8.85Z"
  })));
};
export default SvgPromoIconinline;